<script lang="ts">
  import { Layout } from "../../components"
  import { Form, TextField, Button, Checkbox } from "@gl/design-system"
  import { _ } from "svelte-i18n"
  import { createChannel, getChannel, patchChannel } from "../../services/endpoints"
  import type { Channel } from "../../services/models"
  import { navigateCustom } from "../../utils/navigateCustom"
  import { onMount } from "svelte"

  export let uuid: string | null = null;

  let form: Channel = {
    name: "",
    mediastorePath: "",
    externalId: null,
    active: true
  }

  function create() {
    createChannel(form).then(channel => navigateCustom("/channels/" + channel.uuid))
  }

  function update() {
    patchChannel(uuid, form).then(channel => navigateCustom("/channels/" + channel.uuid))
  }

  onMount(() => {
    if(uuid) {
      getChannel(uuid).then(channel => form = channel)
    }
  })
</script>

<Layout selected="channels">
  <Form>
    <TextField label="Channel-Name" required={true} bind:value={form.name}/>
    <TextField label="Mediastore Path" bind:value={form.mediastorePath}/>
    <TextField label="ExternalId" bind:value={form.externalId}/>
    <Checkbox label="active" bind:value={form.active}/>
    {#if uuid}
    <Button on:click={() => update()}>
      {$_("common.update")}
    </Button>
    {:else}
    <Button on:click={() => create()}>
      {$_("common.create")}
    </Button>
    {/if}
  </Form>
</Layout>
